export default {"src":"/_next/static/media/mileprogram-rank-benefit-table-sp.6780da9e.svg","height":400,"width":319,"blurWidth":0,"blurHeight":0};